package com.essntl.features.crm.domain.model

import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel

data class CreateContactModel(
    val travelAgent: TravelAgentModel?,
    val supplier: SupplierModel?,
)